import { Component, Input, OnInit } from '@angular/core';
import { BaseViewComponent, IconBulletAlignment, IconBulletTextStyle, IconItem, IconSize } from '@sb/library/base';

@Component({
    selector: 'lib-icon-bullet',
    templateUrl: './icon-bullet.component.html',
    styleUrls: ['./icon-bullet.component.scss'],
})

export class IconBulletComponent extends BaseViewComponent implements OnInit {
    // inputs for the new icon bullet
    @Input() icon: IconItem | null = null;
    @Input() suffixIcon: IconItem | null = null;
    @Input() hasHover: boolean = false; // to mimick the hover state if icon bullet is being projected into a menu button (new)
    
    @Input() legacy: boolean = true; // temporary flag for now that uses the old icon bullet styling
    
    // these inputs are legacy inputs
    @Input() size: IconSize = IconSize.ExtraSmall; // legacy
    @Input() iconColorClass!: string; // legacy
    @Input() alignment: IconBulletAlignment = IconBulletAlignment.Center; // legacy
    @Input() textStyle: IconBulletTextStyle = IconBulletTextStyle.Normal;  // legacy

    @Input() qaTag: string = '';
}
